/* recently-viewed.js */

const RECENTLY_VIEWED_KEY = "aaliyans_recently_viewed";
const MAX_ITEMS = 12;

function trackView(handle) {
  if (!handle) return;
  let list = getRecentlyViewed().filter((h) => h !== handle);
  list.unshift(handle);
  list = list.slice(0, MAX_ITEMS);
  localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list));
}

function getRecentlyViewed() {
  try {
    return JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];
  } catch {
    return [];
  }
}

function formatPkr(cents) {
  const n = Math.round(Number(cents || 0) / 100);
  return `PKR ${n.toLocaleString("en-US")}`;
}

document.addEventListener("DOMContentLoaded", async () => {
  const currentHandle = document.querySelector("[data-product-handle]")?.dataset.productHandle;
  if (currentHandle) trackView(currentHandle);

  const section = document.querySelector("[data-recently-viewed-section]");
  if (!section) return;

  const handles = getRecentlyViewed().filter((h) => h !== currentHandle);
  if (!handles.length) return;

  const track = section.querySelector("[data-recently-viewed-track]");
  const products = await Promise.all(
    handles.map((h) => fetch(`/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null))
  );

  const valid = products.filter(Boolean);
  if (!valid.length) return;

  track.innerHTML = valid
    .map((p) => {
      const img = p.featured_image || "";
      const compare = p.compare_at_price;
      const onSale = compare && compare > p.price;
      const pct = onSale ? Math.round(((compare - p.price) / compare) * 100) : 0;
      return `
        <article class="p-card">
          <div class="p-card__media">
            <a class="p-card__link" href="/products/${p.handle}">
              <img src="${img}" width="800" height="1000" alt="${p.title.replace(/"/g, "&quot;")}" loading="lazy">
            </a>
          </div>
          <div class="p-card__body">
            <a href="/products/${p.handle}" class="card-title">${p.title}</a>
            <div class="card-price">
              ${onSale ? `<span class="new">${formatPkr(p.price)}</span><span class="old">${formatPkr(compare)}</span><span class="pct">-${pct}%</span>` : `<span class="new">${formatPkr(p.price)}</span>`}
            </div>
          </div>
        </article>
      `;
    })
    .join("");

  section.hidden = false;
});
